export default "__VITE_ASSET__DaoiEBdB__"